@for (banner of banners(); track banner.id) {
  <p-message
    [severity]="banner.severity"
    [closable]="banner.closable"
    [icon]="banner.icon"
    [pt]="banner.iconColor ? { icon: { style: { color: banner.iconColor } } } : {}"
    (onClose)="dismiss(banner.id)"
    >{{ banner.translationKey | translate: banner.translationParams }}</p-message
  >
}
